import { RESIDENCE_INFO  } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(RESIDENCE_INFO)
